"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonControlsText = exports.CheckboxStateWrapper = exports.PhoneNumberInput = exports.DropdownList = exports.TextboxStateWrapper = exports.LayoutControlsGridCol = exports.LayoutControlsGridLayout = exports.FieldsetGroup = exports.CommonControlsSectionHeader = exports.LayoutControlsPanel = exports.ApplicationContactDetails = void 0;
var React = require("react");
var csod = require("player-core");
var ViewSL_1 = require("./ViewSL");
var Panel_1 = require("player-layout-controls/controls/Panel");
Object.defineProperty(exports, "LayoutControlsPanel", { enumerable: true, get: function () { return Panel_1.Panel; } });
var SectionHeader_1 = require("player-common-controls/controls/SectionHeader");
Object.defineProperty(exports, "CommonControlsSectionHeader", { enumerable: true, get: function () { return SectionHeader_1.SectionHeader; } });
var FieldsetGroup_1 = require("../FieldsetGroup/FieldsetGroup");
Object.defineProperty(exports, "FieldsetGroup", { enumerable: true, get: function () { return FieldsetGroup_1.FieldsetGroup; } });
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
Object.defineProperty(exports, "LayoutControlsGridLayout", { enumerable: true, get: function () { return GridLayout_1.GridLayout; } });
var GridCol_1 = require("player-layout-controls/controls/GridCol");
Object.defineProperty(exports, "LayoutControlsGridCol", { enumerable: true, get: function () { return GridCol_1.GridCol; } });
var TextboxStateWrapper_1 = require("../TextboxStateWrapper/TextboxStateWrapper");
Object.defineProperty(exports, "TextboxStateWrapper", { enumerable: true, get: function () { return TextboxStateWrapper_1.TextboxStateWrapper; } });
var DropdownList_1 = require("../DropdownList/DropdownList");
Object.defineProperty(exports, "DropdownList", { enumerable: true, get: function () { return DropdownList_1.DropdownList; } });
var PhoneNumberInput_1 = require("../PhoneNumberInput/PhoneNumberInput");
Object.defineProperty(exports, "PhoneNumberInput", { enumerable: true, get: function () { return PhoneNumberInput_1.PhoneNumberInput; } });
var CheckboxStateWrapper_1 = require("../CheckboxStateWrapper/CheckboxStateWrapper");
Object.defineProperty(exports, "CheckboxStateWrapper", { enumerable: true, get: function () { return CheckboxStateWrapper_1.CheckboxStateWrapper; } });
var Text_1 = require("player-common-controls/controls/Text");
Object.defineProperty(exports, "CommonControlsText", { enumerable: true, get: function () { return Text_1.Text; } });
var ApplicationContactDetails = (function (_super) {
    __extends(ApplicationContactDetails, _super);
    function ApplicationContactDetails(props) {
        var _this = _super.call(this, props) || this;
        _this.packageName = 'player-application-workflow';
        _this._renderView = _this._renderView.bind(_this);
        _this.viewSL = ViewSL_1.viewSL.apply(_this);
        _this.viewSL.constructor && _this.viewSL.constructor.apply(_this, arguments);
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplicationContactDetails.prototype.componentDidMount = function () {
        this.viewSL.mounted && this.viewSL.mounted.apply(this, arguments);
    };
    ApplicationContactDetails.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.viewSL.shouldUpdate)
            return this.viewSL.shouldUpdate.apply(this, arguments);
        else
            return true;
    };
    ApplicationContactDetails.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.viewSL.didUpdate && this.viewSL.didUpdate.apply(this, arguments);
    };
    ApplicationContactDetails.prototype.componentWillUnmount = function () {
        this.viewSL.unmount && this.viewSL.unmount.apply(this, arguments);
    };
    ApplicationContactDetails.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._processEvent(eventName, args, 4, monikerCallback);
    };
    ApplicationContactDetails.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._processEvent(eventName, args, 2, function () { });
    };
    ApplicationContactDetails.prototype._processEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.viewSL.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                self_1.viewSL.events[eventName].apply(self_1, combinedArgs);
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplicationContactDetails.prototype._renderView = function () {
        var _this = this;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var root_handler = function () {
            return [
                React.createElement(Panel_1.Panel, { key: 0, paddingBottom: "Small", children: [
                        React.createElement(SectionHeader_1.SectionHeader, { key: 0, size: "H2", text: _this.props.sectionTitle })
                    ] }),
                React.createElement(FieldsetGroup_1.FieldsetGroup, { key: 1, legend: _this.props.sectionTitle, children: [
                        React.createElement(GridLayout_1.GridLayout, { key: 0, gutterHorizontal: "Medium", gutterVertical: "Small", children: [
                                React.createElement(GridCol_1.GridCol, { key: 0, width: "12", widthForSm: "6", children: [
                                        React.createElement(TextboxStateWrapper_1.TextboxStateWrapper, { key: 0, label: _this.props.addressLine1.title, ariaLabel: _this.props.addressLine1.title, isRequired: _this.props.addressLine1.isRequired, showLabel: true, value: _this.props.addressLine1.value, id: _this.props.addressLine1.idTag, tag: _this.props.addressLine1.idTag, maxLength: 110, errorMessage: _this.props.addressLine1.errorMessage, onChange: _this._proxyEvent("onChange"), onBlur: _this._proxyEvent("onUpdate") })
                                    ] }),
                                React.createElement(GridCol_1.GridCol, { key: 1, width: "12", widthForSm: "6", children: [
                                        React.createElement(TextboxStateWrapper_1.TextboxStateWrapper, { key: 0, label: _this.props.addressLine2.title, ariaLabel: _this.props.addressLine2.title, isRequired: _this.props.addressLine2.isRequired, showLabel: true, value: _this.props.addressLine2.value, id: _this.props.addressLine2.idTag, tag: _this.props.addressLine2.idTag, maxLength: 55, errorMessage: _this.props.addressLine2.errorMessage, onChange: _this._proxyEvent("onChange"), onBlur: _this._proxyEvent("onUpdate") })
                                    ] }),
                                React.createElement(GridCol_1.GridCol, { key: 2, width: "12", widthForSm: "6", children: [
                                        React.createElement(TextboxStateWrapper_1.TextboxStateWrapper, { key: 0, label: _this.props.city.title, ariaLabel: _this.props.city.title, isRequired: _this.props.city.isRequired, showLabel: true, value: _this.props.city.value, id: _this.props.city.idTag, tag: _this.props.city.idTag, maxLength: 35, errorMessage: _this.props.city.errorMessage, onChange: _this._proxyEvent("onChange"), onBlur: _this._proxyEvent("onUpdate") })
                                    ] }),
                                React.createElement(GridCol_1.GridCol, { key: 3, width: "12", widthForSm: "6", children: [
                                        React.createElement(TextboxStateWrapper_1.TextboxStateWrapper, { key: 0, label: _this.props.state.title, ariaLabel: _this.props.state.title, isRequired: _this.props.state.isRequired, showLabel: true, value: _this.props.state.value, id: _this.props.state.idTag, tag: _this.props.state.idTag, maxLength: 30, errorMessage: _this.props.state.errorMessage, onChange: _this._proxyEvent("onChange"), onBlur: _this._proxyEvent("onUpdate") })
                                    ] }),
                                React.createElement(GridCol_1.GridCol, { key: 4, width: "12", widthForSm: "6", children: [
                                        React.createElement(DropdownList_1.DropdownList, { key: 0, label: _this.props.country.title, items: _this.props.country.items, width: "Block", value: _this.props.country.value, id: _this.props.country.idTag, tag: _this.props.country.idTag, onChange: _this._proxyEvent("onCountryChange") })
                                    ] }),
                                React.createElement(GridCol_1.GridCol, { key: 5, width: "12", widthForSm: "3", children: [
                                        React.createElement(TextboxStateWrapper_1.TextboxStateWrapper, { key: 0, label: _this.props.zip.title, ariaLabel: _this.props.zip.title, isRequired: _this.props.zip.isRequired, showLabel: true, value: _this.props.zip.value, id: _this.props.zip.idTag, tag: _this.props.zip.idTag, maxLength: 20, errorMessage: _this.props.zip.errorMessage, onChange: _this._proxyEvent("onChange"), onBlur: _this._proxyEvent("onUpdate") })
                                    ] }),
                                React.createElement(GridCol_1.GridCol, { key: 6, width: "12", widthForSm: "6", children: [
                                        React.createElement(PhoneNumberInput_1.PhoneNumberInput, { key: 0, label: _this.props.phone.title, isRequired: _this.props.phone.isRequired, showLabel: true, value: _this.props.phone.value, isPhoneCountryCodeSelectorVisible: _this.props.phone.isPhoneCountryCodeSelectorVisible, countryLocalizations: _this.props.phone.countryLocalizations, id: _this.props.phone.idTag, tag: _this.props.phone.idTag, maxLength: 30, errorMessage: _this.props.phone.errorMessage, onChange: _this._proxyEvent("onChange"), onBlur: _this._proxyEvent("onUpdate") })
                                    ] }),
                                React.createElement(GridCol_1.GridCol, { key: 7, width: "12", widthForSm: "6", isVisible: _this.props.isOptInTextMessagesVisible, children: [
                                        React.createElement(CheckboxStateWrapper_1.CheckboxStateWrapper, { key: 0, label: _this.props.isUserOptedInTextMessages.title, showLabel: true, isChecked: _this.props.isUserOptedInTextMessages.isValueTrue, isEnabled: true, id: _this.props.isUserOptedInTextMessages.idTag, tag: _this.props.isUserOptedInTextMessages.idTag, errorMessage: _this.props.isUserOptedInTextMessages.errorMessage, onChange: _this._proxyEvent("onChange") })
                                    ] }),
                                React.createElement(GridCol_1.GridCol, { key: 8, width: "12", widthForSm: "12", isVisible: _this.props.isSmsFeatureEnabled, children: [
                                        React.createElement(CheckboxStateWrapper_1.CheckboxStateWrapper, { key: 0, label: _this.props.isSmsOptedIn.title, showLabel: true, isChecked: _this.props.isSmsOptedIn.isValueTrue, isEnabled: true, id: _this.props.isSmsOptedIn.idTag, tag: _this.props.isSmsOptedIn.idTag, errorMessage: _this.props.isSmsOptedIn.errorMessage, onChange: _this._proxyEvent("onChange") })
                                    ] }),
                                React.createElement(GridCol_1.GridCol, { key: 9, width: "12", widthForSm: "12", isVisible: _this.props.smsOptInOutDateVisiable, children: [
                                        React.createElement(Text_1.Text, { key: 0, text: _this.props.smsOptInOutDate, tag: "smsOptInDate-idTag", size: "Small" })
                                    ] })
                            ] })
                    ] })
            ];
        };
        return root_handler();
    };
    ApplicationContactDetails.prototype.render = function () {
        return (React.createElement("div", { className: "p-viewSL-applicationcontactdetails" }, this._renderView()));
    };
    ApplicationContactDetails.defaultProps = {
        sectionTitle: '', addressLine1: '', addressLine2: '', city: '', state: '', country: '', zip: '', phone: '', isUserOptedInTextMessages: false, isOptInTextMessagesVisible: false, isSmsOptedIn: false, isSmsFeatureEnabled: false, smsOptInOutDate: '', smsOptInOutDateVisiable: false,
        onChange: function () { }, onUpdate: function () { }, onCountryChange: function () { }
    };
    return ApplicationContactDetails;
}(React.Component));
exports.ApplicationContactDetails = ApplicationContactDetails;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplicationContactDetails"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationContactDetails/ApplicationContactDetails.js
// module id = 270
// module chunks = 0 1